import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Fab, Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';

class FormCancelButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        handleCancel: PropTypes.func.isRequired
    };

    static defaultProps = {};

    render() {
        const { handleCancel, classes } = this.props;

        return (
            <Tooltip title={Translator.translate('general.cancel')} placement="top">
                <Fab
                    aria-label={Translator.translate('general.cancel')}
                    className={`${classes.btnEdit} ${classes.fabCancel}`}
                    size="small"
                    onClick={handleCancel}
                >
                    <Close className={classes.icon} />
                </Fab>
            </Tooltip>
        );
    }
}

const styles = theme => ({
    fabCancel: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.error.main,
        position: 'absolute',
        top: 50,
        right: 100,
        [theme.breakpoints.down('sm')]: {
            top: 80,
            right: 30
        },
        [theme.breakpoints.down('xs')]: {
            top: 58,
            right: 18
        }
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
});

export default withStyles(styles, { withTheme: true })(FormCancelButton);



// WEBPACK FOOTER //
// ./data/components/FormCancelButton.js